import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { getCategories } from "./categoryServices";

function CategoryGrid({ onCategoryClick }) {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const categoryList = await getCategories();
        setCategories(categoryList);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchCategories();
  }, []);

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(3, 1fr)",
        gap: 2,
        padding: 2,
      }}
    >
      {categories.map((category, index) => (
        <Box
          key={index}
          onClick={() => onCategoryClick(category)}
          sx={{
            textAlign: "center",
            backgroundColor: "#fff",
            padding: 2,
            borderRadius: 2,
            boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
            cursor: "pointer",
            transition: "transform 0.3s ease", // Smooth transition for the hover effect
            "&:hover": {
              transform: "translateY(-5px)", // Moves the card up by 5px on hover
              boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)", // Optional: Adds a shadow effect on hover
            },
          }}
        >
          <img
            src={category.catImg}
            alt={category.catName}
            style={{
              width: "100%",
              borderRadius: 8,
              maxHeight: 150,
              objectFit: "cover",
            }}
          />
          <Typography variant="body1" sx={{ marginTop: 1, fontWeight: "bold" }}>
            {category.catName}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}

export default CategoryGrid;
